// extracted by mini-css-extract-plugin
export default {"banner":"app-banner_banner__O9t7i"};